// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Button} from './../button/Button'
import {Icon} from './../icon/Icon'

// Mixins
import {FormInput} from './../../../mixins/form_input/FormInput'

// Flatpicker
import Flatpickr from 'flatpickr'
import { english } from 'flatpickr/dist/l10n/default.js'
import { German } from 'flatpickr/dist/l10n/de.js'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import { Czech } from 'flatpickr/dist/l10n/cs.js'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import { Swedish } from 'flatpickr/dist/l10n/sv.js'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import { Mandarin } from 'flatpickr/dist/l10n/zh.js'
import { Korean } from 'flatpickr/dist/l10n/ko.js'
import { Romanian } from 'flatpickr/dist/l10n/ro.js'
import { Slovak } from 'flatpickr/dist/l10n/sk.js'


@Component({
    name: 'Input',
    components: {
        Button,
        Icon,
    },
    mixins: [
        template,
    ]
})
export class Input extends mixins(FormInput) {

    public get inputIcon() {

        const iconMap = {
            dtp: this.$icons.CALENDAR_TIME,
        }

        return iconMap[this.type]
    }

    public get isSpecial() {
        return this.type == 'dtp'
    }

    public get themeMap() {
        const themeMap = {
            default: 1,
            secondary: 2
        }

        return themeMap[this.theme] ? themeMap[this.theme] : themeMap['default']
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get inputClass() {
        return `wb-e-inp-${this.themeMap}`
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0  ? `${this.$appPrefix}-input--error wb-e-inp-${this.themeMap}--has-error` : ''
    }

    public flatpicker: any = null

    @Prop()
    public type!: string

    @Prop()
    public min!: number

    @Prop()
    public max!: number

    @Prop()
    public maxlength!: number

    @Prop()
    public step!: number

    @Prop()
    public theme!: string

    @Prop([String, Number, Date])
    public value!: any

    @Prop()
    public label!: string

    @Prop()
    public placeholder!: string

    @Prop()
    public info!: string

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({type: [Object],default: () => ({defaultDate: null, altInput: true, altFormat: "d.m.Y", dateFormat: 'Y-m-d'})})
    public dtConfig!: any

    @Prop({default: false})
    public disabled!: boolean

    @Prop()
    public id!: string

    @Prop()
    public name!: string

    @Prop({default: true})
    public showErrors!: boolean

    @Prop({default: false})
    public readonly!: boolean

    @Prop({default: "0"})
    public tabindex!: string

    @Watch('value')
    public valueChange(newVal) {

        if (this.type === 'dtp') {

            if (newVal === this.$refs.input.value) return

            this.flatpicker && this.flatpicker.setDate(newVal, true)
        }
    }

    // Types
    public $refs!: {
        input: any
    }

    public created () {

    }

    public mounted() {

        if (this.type === 'dtp') {

            if (this.flatpicker) return

            const onCloseEmitVal = {
                onClose: (dates, currentDateString, picker) => {
                    picker.setDate(picker.altInput.value, true, picker.config.altFormat);
                    picker.altInput.blur();
                },
            }
            let config = Object.assign({}, {defaultDate: null, altInput: true, altFormat: "d.m.Y", dateFormat: 'Y-m-d'},onCloseEmitVal, this.dtConfig)

            config.defaultDate = this.value || config.defaultDate
            config.locale = this.getFlatpickrLocale( this.dtConfig.locale );

            this.flatpicker = Flatpickr(this.$refs.input, config)
        }
    }

    private getFlatpickrLocale(lang: string) {
        switch (lang) {
            case 'br':
            case 'pt':
                return Portuguese;
            case 'cs':
                return Czech;
            case 'de':
                return German;
            case 'en':
                return english;
            case 'es':
                return Spanish;
            case 'fr':
                return French;
            case 'it':
                return Italian;
            case 'ko':
                return Korean;
            case 'nl':
                return Dutch;
            case 'pl':
                return Polish;
            case 'ro':
                return Romanian;
            case 'ru':
                return Russian;
            case 'sk':
                return Slovak;
            case 'sv':
                return Swedish;
            case 'tr':
                return Turkish;
            case 'zh':
                return Mandarin;
            default:
                return German;
        }
    }

    public destroyed() {
        this.flatpicker = null
    }

    public handleChange(value: any) {
        this.$emit('input', value)
    }

    public handleBlur(value: any) {
        this.$emit('blur', value)
    }

    public handleKeyup(e: any) {
        this.$emit('keyup', e)
    }

    private handleSubmit(e: any) {
        
        if (this.type != 'dtp') {
            this.dispatch('Form', 'submitForm', [])
        }
    }
}